import styled, {css} from 'styled-components'

import {Text} from '../../text'

const defaultStyles = {
  position: 'relative',
  marginBottom: 16,
  paddingLeft: 32,
  '&:last-child': {
    marginBottom: 0,
  },
  '&:before': {
    position: 'absolute',
  },
}

const bulletItem = css`
  &:before {
    position: absolute;
    content: '•';
    border-radius: 50%;
    left: 0;
    top: 0;
  }
`

const numbersItem = css`
  &:before {
    position: absolute;
    counter-increment: number;
    content: counter(number) '.';
    font-weight: 500;
    left: 0;
    top: 0;
  }
`

const ListItem = styled(Text).attrs(({$styles = {}}) => ({
  as: 'li',
  $styles: {...defaultStyles, ...$styles},
}))`
  p {
    margin: 0;

    font-size: inherit;
    line-height: inherit;
  }

  ul & {
    ${bulletItem}
  }

  ol & {
    ${numbersItem}
  }
`

export default ListItem
